import { inject, Injectable, signal } from '@angular/core'
import { MenuController } from '@ionic/angular/standalone'

import { environment } from '../../../environments/environment'
import { AuthService } from './auth.service'
import { DomainService } from './domain.service'
import { HelperService } from './helper.service'

export type DisplayMode = 'time' | 'league'

@Injectable({
	providedIn: 'root',
})
export class DisplayService {
	private readonly STORAGE_KEY = 'display_mode'

	private readonly menuController = inject(MenuController)

	private readonly authService = inject(AuthService)

	private readonly helperService = inject(HelperService)

	private readonly domainService = inject(DomainService)

	displayMode = signal<DisplayMode>('league')

	constructor() {
		const savedMode = localStorage.getItem(this.STORAGE_KEY) as DisplayMode
		if (savedMode && (savedMode === 'time' || savedMode === 'league')) {
			this.displayMode.set(savedMode)
		} else {
			// Set default to league if no saved preference
			localStorage.setItem(this.STORAGE_KEY, 'league')
		}
	}

	async setMode(mode: DisplayMode) {
		this.displayMode.set(mode)
		localStorage.setItem(this.STORAGE_KEY, mode)
		// Close the drawer when mode is changed
		await this.menuController.close()
	}

	async openCasino() {
		const base = `https://${environment.casinoDomain}.${this.domainService.domain}`

		const userData = this.helperService.getUserData()
		if (!userData) {
			console.error('No user data available for casino')
			return
		}

		const userFields = userData.user_fields
		const userToken = this.authService.getAccessToken()
		const { CURRENCY, ID, NAME, LANGUAGE } = userFields ?? {}

		const qs = new URLSearchParams({
			token: userToken,
			tokenTimestamp: String(Date.now()),
			userFields: JSON.stringify(userFields),
			userId: ID,
			currency: CURRENCY,
			displayName: NAME,
			lang: LANGUAGE,
		})

		window.open(`${base}?${qs.toString()}`, '_blank', 'noopener,noreferrer')
	}
}
